import { render, staticRenderFns } from "./Evalua.vue?vue&type=template&id=17ca20f5&lang=true"
import script from "./Evalua.vue?vue&type=script&lang=js"
export * from "./Evalua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports